'use strict';

export { createAnimatedComponent } from './createAnimatedComponent';
//# sourceMappingURL=index.js.map